<template>
    <div class="container mt-5 ql-editor">
        <div v-html="description">
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlanDetailsDescription',
    props: {
        description: {
            type: String,
            required: true,
        },
    },

};
</script>

<style>

</style>
